/* eslint-disable no-async-promise-executor */
import { canvasRequest } from '$/api/canvasRquest';
import APP from '$/api/api';
import {
  InputPromptData, V3CanvasHomeCategoriesData,
} from './type';

/**
 * 获取首页输入框 Skill 列表（分类 + 技能）
 *
 * @export
 * @return {*}  {Promise<InputPromptData>}
 */
export async function getHomeInputPrompt(): Promise<InputPromptData> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {},
      method: 'GET',
      url: APP.roboneo.api.homeInputPrompt,
    });
    if (response.status === 200 && response.data.code === 0) {
      const groups = response.data.data?.groups || [];
      const categories: InputPromptData['categories'] = [];
      const list: InputPromptData['list'] = [];
      groups.forEach((group: any) => {
        categories.push({ id: group.id, name: group.name, icon: group.icon || '' });
        (group.prompts || []).forEach((prompt: any) => {
          list.push({
            id: prompt.id,
            name: prompt.name,
            desc: prompt.desc,
            cover_list: prompt.cover_list || [],
            category_id: group.id,
            category_icon: group.icon || '',
          });
        });
      });
      resolve({ categories, list });
      return;
    }
    reject(response);
  });
}

/**
 * 获取首页运营分类列表（含每分类预览案例）
 *
 * @export
 * @param {{ type?: string; preview_count?: number }} [params]
 * @return {*}  {Promise<V3CanvasHomeCategoriesData>}
 */
export async function getHomeCategories(params?: { type?: string;
  preview_count?: number;
  scene?: 'case' | 'home_input';
  with_graph?: 0 | 1; }): Promise<V3CanvasHomeCategoriesData> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        type: params?.type || 'teams',
        preview_count: params?.preview_count || 6,
        scene: params?.scene,
        with_graph: params?.with_graph,
      },
      method: 'GET',
      url: APP.roboneo.api.canvasHomeCategoriesV3,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 获取首页分类案例详情列表
 *
 * @export
 * @param {object} params
 * @param {number} params.category - 分类 ID
 * @return {*}
 */
export async function getHomeCasesListV3(params: {
  type?: string;
  category?: number;
  page?: number;
  count?: number;
  case_id?: number;
  index?: number;
  scene?: 'case' | 'home_input' | 'room_input';
  with_graph?: 0 | 1;
}) {
  return new Promise<any>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params,
      method: 'GET',
      url: APP.roboneo.api.canvasHomeCasesListV3,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 获取首页分类案例详情
 *
 * @export
 * @param {object} params
 * @param {number} params.category - 分类 ID
 * @return {*}
 */
export async function getHomeCaseV3(params: {
  category?: number;
  case_id: number;
}) {
  return new Promise<any>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params,
      method: 'GET',
      url: APP.roboneo.api.canvasHomeCaseV3,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}
